import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME } from "utils/constant";
import { GrideDateFormatter } from "ui/Date";
//import styles from "styles.module.css";
import i18n from "../../../i18n";
import { CheckMarkCell } from "ui/grid/CheckMarkCell";
import { compareAsc } from "date-fns";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import DotCell from "ui/grid/DotCell";

let t = i18n.t;

export const InvoiceGridColumnItem = (statusOverrides?: Record<number, number>) => {
	const gridItems: GridColumnProps[] = [
		{
			field: "",
			title: "",
			width: "0px",
			headerClassName: "no-border",
		},
		{
			field: "",
			title: "",
			width: "30px",
			headerClassName: "no-border",
			cell: (props) => (
				<DotCell value={statusOverrides?.[props.dataItem.id] ?? props.dataItem.status} />
			),
		},
		{
			field: "invoiceDate",
			title: t("Invoiced"),
			headerClassName: "no-border",
			width: "95px",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.invoiceDate}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "dueDate",
			title: t("DueDate"),
			headerClassName: "no-border",
			width: 95,
			cells: {
				data: (props) => (
					<GrideDateFormatter
						style={{
							color: isDueDatePassed(
								props.dataItem.dueDate,
								props.dataItem.remainingValue
							)
								? "red"
								: "",
						}}
						date={props.dataItem.dueDate}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "invoiceNumber",
			title: t("InvoiceNumber"),
			width: "150px",
			headerClassName: "no-border",
			cells: {
				data: (props) => {
					return (
						<td style={props.style} className={props.className + " no-border"}>
							<span>{`${props.dataItem.invoiceType}  ${props.dataItem["invoiceNumber"]}`}</span>
						</td>
					);
				},
			},
		},
		{
			field: "customerName",
			title: t("BuyerName"),
			headerClassName: "no-border",
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "printedDate",
			title: t("PrintDate"),
			width: 110,
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.printedDate}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{ field: "printedBy", title: t("PrintedBy") },
		{
			field: "ehfAccessResponse",
			title: "EHF",
			width: 40,
			cells: {
				data: (props) => (
					<CheckMarkCell
						{...props}
						checked={(props.dataItem["invoiceSentDate"] !== null && props.dataItem["invoiceSentDate"] !== undefined) ? true : false}
					/>
				),
			},
		},
		{
			field: "netValue",
			title: t("BuyerNetAmount"),
			width: "130px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => (
					<NumericalCell {...props} unit={"kr"} formatDecimal={2} />
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
		{
			field: "grossValue",
			title: t("BuyerGrossAmount"),
			width: "130px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => (
					<NumericalCell {...props} unit={"kr"} formatDecimal={2} />
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
		//{
		//	field: "paidValue",
		//	title: "Betalt",
		//	width: "120px",
		//	headerClassName: CLASSNAME.TableNumeric,
		//	className: `${CLASSNAME.TableNumeric} no-border`,
		//	cells: {
		//		data: (props) => (
		//			<NumericalCell {...props} unit={"kr"} formatDecimal={2} />
		//		),
		//		headerCell: (props) => <NumericalHeader {...props} />,
		//	},
		//},
	//	{
	//		field: "remainingValue",
	//		title: "Restbeløp",
	//		width: "120px",
	//		headerClassName: CLASSNAME.TableNumeric,
	//		className: `${CLASSNAME.TableNumeric} no-border`,
	//		cells: {
	//			data: (props) => (
	//				<NumericalCell
	//					{...props}
	//					style={{
	//						color: isDueDatePassed(
	//							props.dataItem.dueDate,
	//							props.dataItem.remainingValue
	//						)
	//							? "red"
	//							: "",
	//					}}
	//					unit={"kr"}
	//					formatDecimal={2}
	//				/>
	//			),
	//			headerCell: (props) => <NumericalHeader {...props} />,
	//		},
	//	},
	];
	return gridItems;
};

const isDueDatePassed = (dueDate: Date, remainingValue: number) => {
	const result = compareAsc(new Date(dueDate), new Date());
	return result === -1 && remainingValue !== 0;
};
